import { DataConnection } from '@nimmsta/ng-commons-lib/models';
import { CsvParserConfiguration } from './csvParserConfiguration';

export interface SortingConfiguration extends CsvParserConfiguration {
  keyField: string;
  validityDays: number;
}

export interface SortingDataConnection extends DataConnection {
  configuration: SortingConfiguration;
}

export type SortingUploadRequest = {
  uploadId: string;
} & (
  | { format: 'csv'; data: string }
  | { format: 'json'; data: Record<string, unknown>[] }
);

export type SortingImportStatus =
  'QUEUED' | 'VALIDATING' | 'IMPORTING' | 'COMPLETED' | 'FAILED' | 'CANCELLED';

export interface SortingImportResponse {
  id: string;
  status: SortingImportStatus;
  processed: number;
  total: number;
  errorCode: string | null;
  acceptedAt: string;
}

export function isSortingImportPending(status: SortingImportStatus): boolean {
  return (
    status === 'QUEUED' || status === 'VALIDATING' || status === 'IMPORTING'
  );
}
